/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseProductListingFragment, ProductListingFragment, FullProductListingFragment} from '@amblique/contentful/app/contentful/fragments/product-listing';

/**
 * Get a single ProductListing by ID (base - scalars only)
 */
export const getBaseProductListingById = gql`
  ${BaseProductListingFragment}

  query GetBaseProductListingById($id: String!, $locale: String!, $preview: Boolean) {
    productListing(id: $id, locale: $locale, preview: $preview) {
      ...BaseProductListingFragment
    }
  }
`;

/**
 * Get a single ProductListing by ID (standard - 1 level deep)
 */
export const getProductListingById = gql`
  ${ProductListingFragment}

  query GetProductListingById($id: String!, $locale: String!, $preview: Boolean) {
    productListing(id: $id, locale: $locale, preview: $preview) {
      ...ProductListingFragment
    }
  }
`;

/**
 * Get a single ProductListing by ID (full - 2 levels deep)
 */
export const getFullProductListingById = gql`
  ${FullProductListingFragment}

  query GetFullProductListingById($id: String!, $locale: String!, $preview: Boolean) {
    productListing(id: $id, locale: $locale, preview: $preview) {
      ...FullProductListingFragment
    }
  }
`;

/**
 * Get all ProductListing entries with pagination (base - scalars only)
 */
export const getBaseProductListings = gql`
  ${BaseProductListingFragment}

  query GetBaseProductListings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ProductListingOrder]
    $where: ProductListingFilter
    $preview: Boolean
  ) {
    productListingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseProductListingFragment
      }
    }
  }
`;

/**
 * Get all ProductListing entries with pagination (standard - 1 level deep)
 */
export const getProductListings = gql`
  ${ProductListingFragment}

  query GetProductListings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ProductListingOrder]
    $where: ProductListingFilter
    $preview: Boolean
  ) {
    productListingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ProductListingFragment
      }
    }
  }
`;

/**
 * Get all ProductListing entries with pagination (full - 2 levels deep)
 */
export const getFullProductListings = gql`
  ${FullProductListingFragment}

  query GetFullProductListings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ProductListingOrder]
    $where: ProductListingFilter
    $preview: Boolean
  ) {
    productListingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullProductListingFragment
      }
    }
  }
`;
